import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';

const routes: Routes = [
  {
    path: '', component: HomeComponent
  },
  {
    path: 'payment-gateway-connected/:token', component: HomeComponent
  },
]

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    NgxShimmerLoadingModule
  ]
})
export class HomeModule { }
